import { OVERLAY_LAYER } from '../../../../common/constants';
import {
  LABELS_FILL_COLOR,
  METADATA_TEXT_COLOR,
  OVERLAY_COLOR_OPAQUE,
  PRIMARY_FILL_COLOR,
  SIDEBAR_SIZE_LARGE,
  SIDEBAR_SIZE_MEDIUM
} from '../../../theme/colors';

export const ZAP_WRAPPER = {
  position: 'absolute',
  top: 0,
  right: 0,
  width: 'max-content',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  aligntItems: 'center'
};

export const ZAP_CONTENT = {
  default: {
    borderRadius: '10px 0px 0px 10px',
    width: 64,
    display: 'flex',
    alignItems: 'center',
    background: OVERLAY_COLOR_OPAQUE,
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '8px 0px'
  },
  smallContainer: {
    width: 44,
    padding: '7px 0px'
  },
  'largeContainer+extraLargeContainer': {
    width: 80
  }
};

export const ZAP_BUTTON_LABEL = {
  default: {
    transform: 'translateY(0)',
    top: '82%'
  },
  smallContainer: {
    top: '94%'
  }
};

export const ZAP_BUTTON_SIZE_OVERRIDE = {
  width: '100%',
  height: 'inherit',
  cursor: 'pointer'
};

export const ZAP_BUTTON_SIZE = {
  default: {
    margin: 'auto'
  },
  smallContainer: {
    padding: '6px 0' // 6px from top and bottom = 12px gap between vertical zap icons
  },
  'mediumContainer+largeContainer+extraLargeContainer': {
    padding: '7px 0' // 7px from top and bottom = 14px gap between vertical zap icons
  }
};

export const ZAP_ICON_SIZE = {
  smallContainer: { size: 20 },
  mediumContainer: { size: 28 },
  'largeContainer+extraLargeContainer': { size: 32 }
};

export const PANEL_LIVE_OPTION_WRAPPER_STYLE_OPENED = {
  default: {
    background: OVERLAY_COLOR_OPAQUE,
    color: 'white',
    zIndex: OVERLAY_LAYER + 2,
    position: 'absolute',
    right: 0,
    width: `${SIDEBAR_SIZE_MEDIUM}%`
  },
  'largeContainer+extraLargeContainer': {
    width: `${SIDEBAR_SIZE_LARGE}%`
  },
  smallContainer: {
    width: '100%'
  }
};

export const PANEL_TITLE = {
  default: { fontSize: 24, lineHeight: '24px', padding: 16, fontWeight: 700, color: PRIMARY_FILL_COLOR, fontFamily: 'Brown' },
  smallContainer: { fontSize: 14, padding: 12 },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 32 },
  mediumContainer: { paddingTop: 18 },
  'largeContainer+extraLargeContainer': { paddingTop: 24 }
};

export const PANEL_PROGRAM_TITLE = {
  default: {
    fontSize: 16,
    padding: '2px 16px',
    fontWeight: 700, color: PRIMARY_FILL_COLOR, fontFamily: 'Brown'
  },
  small: { fontSize: 12 },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 24 }
};

export const PANEL_PROGRAM_SUBTITLE = {
  default: {
    fontSize: 14,
    padding: '2px 16px',
    fontWeight: 400,
    color: LABELS_FILL_COLOR,
    fontFamily: 'Brown'
  },
  small: { fontSize: 12 },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 20 }
};

export const PANEL_PROGRAM_DESCRIPTION = {
  default: {
    fontSize: 14,
    color: LABELS_FILL_COLOR,
    fontWeight: 400,
    padding: 16,
    fontFamily: 'Brown'
  },
  small: { fontSize: 12 },
  'largeTvContainer+extraLargeTvContainer': {
    fontSize: 24,
    color: LABELS_FILL_COLOR,
    padding: 16
  }
};

export const PANEL_PROGRAM_METADATA = {
  default: { fontSize: 12, padding: '4px 16px', fontWeight: 700, color: METADATA_TEXT_COLOR, fontFamily: 'Brown' },
  'largeTvContainer+extraLargeTvContainer': { fontSize: 20 }
};

export const PANEL_CLOSE_LABEL = {
  default: {
    right: 10,
    top: 90
  },
  smallContainer: { top: 80 }
};
export const PANEL_CLOSE_BUTTON = {
  default: {
    position: 'absolute',
    width: 'max-content',
    right: 6,
    top: 18,
    transform: 'translate(-25%, 25%)'
  },
  smallContainer: { top: 15 },
  mediumContainer: { top: 9, right: 9 },
  'largeContainer+extraLargeContainer': { top: 15, right: 15 }
};
export const PANEL_CLOSE_BUTTON_SIZE = { smallContainer: { width: 16 }, default: { width: 24 } };
